import {
  isViewAsSessionId,
  readStoredViewAs,
  VIEW_AS_STORAGE_KEY,
} from "./viewAsStorage";

// Fixed by the head script before any bundle ran, so the identity a page sends cannot change under it.
export const getViewAsSessionId = (): string | null => {
  if (typeof window === "undefined") return null;

  const sessionId = window.__VIEW_AS__?.sessionId;
  return isViewAsSessionId(sessionId) ? sessionId : null;
};

// True for the life of a tab that opened into a session, ended or not; whether it is over is the viewAs state.
export const isViewAsTab = (): boolean => getViewAsSessionId() !== null;

export const watchViewAsStorage = (
  onSessionGone: VoidFunction,
  onSessionAppeared?: VoidFunction
): void => {
  if (typeof window === "undefined") return;

  const reconcile = () => {
    const sessionId = getViewAsSessionId();
    // Storage that cannot be read says nothing about the session.
    const stored = readStoredViewAs();
    if (!stored.available) return;

    // An ordinary tab stops, then reloads into the session another tab started, so the whole browser is in it.
    if (!sessionId) {
      if (stored.session) {
        window.DO_NOT_TRACK = true;
        onSessionAppeared?.();
        window.location.reload();
      }
      return;
    }

    if (stored.session?.sessionId === sessionId) return;

    onSessionGone();
  };

  window.addEventListener("storage", (event: StorageEvent) => {
    if (event.key !== null && event.key !== VIEW_AS_STORAGE_KEY) return;
    reconcile();
  });

  // Storage may have moved on between the head script binding this page and the bundle subscribing.
  reconcile();
};
